export const useCtaLinkUrl = (cta: CTA | undefined): VNuxtLinkTo => {
    if (!cta) return null

    const [id, search] = cta.link.split('?')
    const query = search
        ? Object.fromEntries(new URLSearchParams(`${search}`))
        : {}

    const result: VNuxtLinkTo = {
        params: { id },
        query,
    }

    if (cta?.link_type === 'form') {
        result.name = 'online-services-detail'
        return result
    }

    if (cta?.link_type === 'product') {
        result.name = 'insurance-detail'
        return result
    }

    return cta.link
}
